import { ErrorHandler } from '@angular/core';
import { GlobalErrorHandler } from '../error-handlers/global.error-handler';

export const errorHandlerProvider = { provide: ErrorHandler, useClass: GlobalErrorHandler };
